import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card,Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";

const modeloDatos = {
    sucursalID: 0,
    empresaID: 0,
    siglas: "",
    descripcion: "",
    rnc: "",
    telefono: "1",
    direccion: "",
    email: "",
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date,
    estatus: true,
    logo: "",
    noWhatsapp: "",
    tokenWhatsapp: "",
    plantillaWhatsapp: ""

}

const Sucursal = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [Controlfecha, setControlfecha] = useState();
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))

    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Administracion/listaSucursal/0");
        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)



        }
    }

    useEffect(() => {
        obtenerDatos();
    },[])


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        tabla.empresaID = JSON.parse(user).empresaID;
        if (tabla.SucursalID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Administracion/GuardarSucursal", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Administracion/EditarSucursal", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {

            if (tabla.activa == false) {
                setTabla(modeloDatos);
                setVerModal(!verModal);
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.empresaID,
            sortable: true,
        },
        {
            name: 'Texto ',
            selector: row => row.descripcion,
            sortable: true,
        },


        {
            name: 'Estatus',
            selector: row => row.estatus,
            sortable: true,
            cell: row => {
                let clase;
                clase = row.estatus ? "badge badge-info p-2" : "badge badge-danger p-2"
                return (
                    <span className={clase}>{row.estatus ? "Activo" : "No Activo"}</span>
                )
            }
        },
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>


                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Sucursales
                </CardHeader>
                <CardBody>
                    <Button color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nueva Sucursal</Button>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal}>
                <ModalHeader>
                    <a className="btn" onClick={cerrarModal}>X</a>  Mantenimiento de Sucursal
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <Label>Descripcion </Label>
                                <Input  bsSize="sm" name="descripcion" onChange={handleChange} value={tabla.descripcion} />
                            </FormGroup>
                        </Col>
                    
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>RNC</Label>
                                <Input  bsSize="sm" name="rnc" onChange={handleChange} value={tabla.rnc} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Siglas</Label>
                                <Input bsSize="sm" name="siglas" onChange={handleChange} value={tabla.siglas} />

                            </FormGroup>
                        </Col>

                        <Col sm={6}>
                            <FormGroup>
                                <Label>Telefono</Label>
                                <Input  bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Email</Label>
                                <Input bsSize="sm" name="email" onChange={handleChange} value={tabla.email} />

                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <Label>Direccion</Label>
                                <Input type="textarea" bsSize="sm" name="direccion" onChange={handleChange} value={tabla.direccion} />

                            </FormGroup>
                        </Col>
                       
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>No WhatsApp (META)</Label>
                                <Input bsSize="sm" name="noWhatsapp" onChange={handleChange} value={tabla.noWhatsapp} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Plantilla Whatsapp</Label>
                                <Input bsSize="sm" name="plantillaWhatsapp" onChange={handleChange} value={tabla.plantillaWhatsapp} />

                            </FormGroup>
                        </Col>
                      
                    </Row>

                    <FormGroup>
                        <Label>Token Whatsapp </Label>
                        <Input bsSize="sm" type="textarea" name="tokenWhatsapp" onChange={handleChange} value={tabla.tokenWhatsapp} />
                    </FormGroup>

                    <Row>
                        <Col sm={4}>
                            <FormGroup>
                                <Label>Estatus</Label>

                                <Input bsSize="sm" type={"select"} name="estatus" onChange={handleChange} value={tabla.estatus} >
                                    <option value={true}>Activo</option>
                                    <option value={false}>No </option>
                                </Input>
                            </FormGroup>
                        </Col>

                       
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <div > <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button></div>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>



        </>
    )

}
export default Sucursal;